module.exports = __webpack_public_path__ + "media/entities/1112-f3039e7e.png";